import { TranslationString } from '../localization';

export type UserTagServer = {
  _id: string;
  name: string;
};

export type ProjectTagServer = {
  _id: string;
  name: string;
  users_count: number;
  date_created: string;
  date_updated: string;
};

export enum ProjectTagErrorCode {
  tagAlreadyExists = 'tag_already_exists',
  tagNotFound = 'tag_not_found'
}

export enum UserTagAssignErrorCode {
  tagAlreadyAssigned = 'tag_already_assigned',
  tagNotAssigned = 'tag_not_assigned',
  tagNotFound = 'tag_not_found'
}

export const mapProjectTagErrorCodeToMessage =
  (code: ProjectTagErrorCode): TranslationString =>
  (t) =>
    t(`projectTag.errors.${code}`, {
      ns: 'entities'
    });

export const mapUserTagAssignErrorCodeToMessage =
  (code: UserTagAssignErrorCode): TranslationString =>
  (t) =>
    t(`userTag.errors.${code}`, {
      ns: 'entities'
    });
